// extracted by mini-css-extract-plugin
export default {"skillsContainer":"Skills_skillsContainer__hz9cG","title":"Skills_title__QXfv9","subTitle":"Skills_subTitle__Bt2dW"};